import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import BookingApp from "./common/BookingApp";
import BookingFormPage from "./booking/BookingFormPage";
import OurFleetPage from "./pages/OurFleetPage";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from '@bugsnag/plugin-react'

Bugsnag.start({
	apiKey: '93400b4cecfaf594a92f1823638b8bb7',
	plugins: [new BugsnagPluginReact()],
	enabledBreadcrumbTypes: ['error', 'log', 'user']
});

class App extends Component {
	constructor() {
		super();
		this.state = {
			form_type: ''
		};
	}

	render() {
		return (
			<BookingFormPage/>
		);
	}
}


const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
window.init_app = (node_dom) => (
	ReactDOM.render(
		<ErrorBoundary>
			<App/>
		</ErrorBoundary>,
		document.getElementById(node_dom))

);

window.init_booking_app = (node_dom, photo_type) => (
    ReactDOM.render(
		<ErrorBoundary>
			<BookingApp photo_key={node_dom} photo_type={photo_type}/>
		</ErrorBoundary>
		, document.getElementById(node_dom+'_div'))
);

window.init_our_fleet_app = (node_dom) => (
    ReactDOM.render(<OurFleetPage/>, node_dom)
);